import React from "react";
import { IInputDate } from "./interface";
import DatePicker from "react-datepicker";

import "./input.scss";
const Component: React.FC<IInputDate> = ({
  startDate,
  onChange,
  placeholder,
}) => {
  return (
    <>
      <div className="w-100">
        <DatePicker
          className="date-pick"
          selected={startDate}
          onChange={onChange}
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="HH:mm"
          placeholderText={placeholder || ""}
        />
      </div>
    </>
  );
};

export default Component;
